<script lang="ts">
	import Media from "@components/common/Media.svelte";
	import type { ContentType } from "@core/schema/ContentType.js";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";
	import MediaTextBlockLayout from "./MediaTextBlockLayout.svelte";

	const { data, lightboxId }: ContentBlockComponentProps<ContentType.ImageText> = $props();
</script>

<MediaTextBlockLayout
	mediaClass="grow-0 shrink-0 w-full !max-w-93 h-100 md:h-140"
	html={data.html}
	reversed={data.reversed}
	{lightboxId}
>
	{#snippet media()}
		<Media
			source={data.image}
			sourcesets={{}}
			alt={data.image.title ?? ""}
			width={800}
			height={800}
			lightbox={lightboxId ?? true}
			lightboxClass="!absolute inset-0 size-full"
			class="size-full object-cover"
			wrapperClass="absolute inset-0"
		/>
	{/snippet}
</MediaTextBlockLayout>
